import Vue from 'vue'
import VueRouter from 'vue-router'
import VueMeta from 'vue-meta'
import NProgress from 'nprogress/nprogress'
import store from '@state/store'
import { allRoutes } from './routes'

Vue.use(VueRouter)
Vue.use(VueMeta, {
  keyName: 'page',
})

const router = new VueRouter({
  routes: allRoutes,
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
})

router.beforeEach(async (routeTo, routeFrom, next) => {

  let session   = store.getters['sessions/GET_SESSIONS_ITEM'];
  let api_token = window.localStorage.getItem('API_KEY_TRADE');

  let session_status = false;

  // if(session.token === null && (api_token === 'undefined' || api_token === null)){
  if(api_token === 'undefined' || api_token === null){

    // Создаем новую сессию
    let new_session = await store.dispatch('sessions/FETCH_SESSIONS_CREATE');
    session = store.getters['sessions/GET_SESSIONS_ITEM'];

    // Если результат success, устанавливаем API_KEY_TRADE
    if(new_session !== false){
      window.localStorage.setItem('API_KEY_TRADE', new_session.token)
      session_status = true;
    }

    // Если ошибка, останавливаем приложение


  } else {

    session_status = true;

    if(api_token === 'undefined' || api_token === null){
      window.localStorage.setItem('API_KEY_TRADE', session.token)
    }

    let resived_session = await store.dispatch('sessions/FETCH_SESSIONS_ITEM');
    session = store.getters['sessions/GET_SESSIONS_ITEM'];

    if(resived_session == false){
      window.localStorage.removeItem('API_KEY_TRADE');
      session_status = false;
      redirectToLogin();
    }
  }

  if(session_status !== false){

    if (routeFrom.name !== null) {
      NProgress.start()
    }

    const authRequired  = routeTo.matched.some((route) => route.meta.authRequired)
    const adminRequired = routeTo.matched.some((route) => route.meta.adminRequired)

    if (!authRequired) return next()

    if(session.user !== null){
      if(adminRequired === false || (adminRequired === true && session.user.role === 'administrator')) {
        return next();
      } else {
        await store.dispatch('sessions/FETCH_SESSIONS_DELETE');
        window.localStorage.removeItem('API_KEY_TRADE');
        window.location.href = "/";
      }
    } else {
      redirectToLogin();
    }
  }

  function redirectToLogin() {
    next({ name: 'login', query: { redirectFrom: routeTo.fullPath } })
  }
})

router.beforeResolve(async (routeTo, routeFrom, next) => {

  try {
    for (const route of routeTo.matched) {
      await new Promise((resolve, reject) => {
        if (route.meta && route.meta.beforeResolve) {
          route.meta.beforeResolve(routeTo, routeFrom, (...args) => {
            if (args.length) {
              if (routeFrom.name === args[0].name) {
                NProgress.done()
              }
              next(...args)
              reject(new Error('Redirected'))
            } else {
              resolve()
            }
          })
        } else {
          resolve()
        }
      })
    }
  } catch (error) {
    return
  }
  next()
})

router.afterEach((routeTo, routeFrom) => {
  NProgress.done()
})

export default router
